<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div v-if="isLoading">Loading AI Model...</div>
                <div v-else>You can move the pointer by moving your face, and you can change pointer color by blinking.</div>
            </div>
        </div>
        <FaceMesh ref="faceMesh" @results="onResults($event)" @doneLoading="isLoading = false" />
  </div>
</template>

<script>
import FaceMesh from "@/components/MediaPipe/FaceMesh"

export default {
    components: { FaceMesh },
    data(){
        return{
            blink: [0, 0],
            hasBlink: false,
            colors: ['red', 'green', 'blue', 'pink', 'purple', 'yellow'],
            currentColor: 0,
            isLoading: true,
        }
    },
    methods:{
        drawEyes(a,c,b, eyePos){
            if(c&&b){
                a.save();
                var e=a.canvas;
                let eyeTopPoint = c[b[12][0]];
                let eyeBottomPoint = c[b[4][0]];
                /*let s = 0
                for(let i = 3; i < 6; i++){
                    s += this.getEyePointDistance(c[b[i+8][0]], c[b[i][0]])
                }
                console.log(
                    s /
                    (this.getEyePointDistance(c[b[15][0]], c[b[8][0]]))
                )*/
                if(eyeBottomPoint.y - eyeTopPoint.y < 0.024){
                    a.fillStyle = "white";
                    if(this.blink[eyePos] != 0 && Date.now() - this.blink[eyePos] < 1000){
                        this.blink[eyePos] = 0;
                        this.currentColor++;
                        if(this.currentColor >= this.colors.length) this.currentColor = 0;
                    } else {
                        this.blink[eyePos] = Date.now();
                    }
                }
                for(let i in b){
                    let g=c[b[i][0]];
                    a.font = "10px Arial";
                    a.fillText(i, g.x*e.width, g.y*e.height);
                }
                a.restore()
            }
        },
        getEyePointDistance(a, b){
            return Math.sqrt(
                Math.pow(a.x - b.x, 2) +
                Math.pow(a.y - b.y, 2) +
                Math.pow(a.z - b.z, 2)
            )
        },
        drawCenter(a,c,b){
            if(c&&b){
                a.save();
                var e=a.canvas;
                let topPos = c[b[0][0]];
                let bottomPos = c[b[18][0]];
                let leftPos = c[b[9][0]];
                let rightPos = c[b[27][0]];

                let frontCenter = {
                    x: (topPos.x + bottomPos.x) / 2,
                    y: (topPos.y + bottomPos.y) / 2,
                    z: (topPos.z + bottomPos.z) / 2,
                }
                let backCenter = {
                    x: (leftPos.x + rightPos.x) / 2,
                    y: (leftPos.y + rightPos.y) / 2,
                    z: (leftPos.z + rightPos.z) / 2,
                }
                let center = {
                    x: (frontCenter.x + backCenter.x) / 2,
                    y: (frontCenter.y + backCenter.y) / 2,
                    z: (frontCenter.z + backCenter.z) / 2,
                }
                let pointer = {
                    x: center.x - e.height / 50 * (backCenter.x - center.x) / (backCenter.z / center.z - 1),
                    y: center.y - e.height / 50 * (backCenter.y - center.y) / (backCenter.z / center.z - 1),
                    z: 0,
                }
                
                a.font = "30px Arial";
                a.fillStyle = this.colors[this.currentColor];
                /*
                a.fillText('O', center.x*e.width, center.y*e.height);
                a.fillText('F', frontCenter.x*e.width, frontCenter.y*e.height);
                a.fillText('B', backCenter.x*e.width, backCenter.y*e.height);
                */
                a.fillText('>OOO<', pointer.x * e.width, pointer.y * e.height);
                a.restore()
            }
        },
        drawConnectors(a,c,b,d){
            if(c&&b){
                a.save();
                var e=a.canvas;
                for(let i in b){
                    let g=c[b[i][0]];
                    a.font = "10px Arial";
                    a.fillStyle = "red";
                    a.fillText(i, g.x*e.width, g.y*e.height);
                }
                a.restore()
            }
        },
        onResults(results){
            const faceMeshComponent = this.$refs.faceMesh
            if (results.multiFaceLandmarks) {
                for (const landmarks of results.multiFaceLandmarks) {
                    this.drawEyes(faceMeshComponent.canvasCtx, landmarks, FACEMESH_LEFT_EYE, 0);
                    this.drawEyes(faceMeshComponent.canvasCtx, landmarks, FACEMESH_RIGHT_EYE, 1);
                    this.drawCenter(faceMeshComponent.canvasCtx, landmarks, FACEMESH_FACE_OVAL);
                }
            }
        },
    },
}
</script>

<style scoped>
</style>